import { TableConfig } from '@shared/interfaces/table/table-config';
import { DashboardQueryUnbalancedQuantityResultDto } from '@app/api/dmc';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { addressPartial, meterNumberPartial } from '@shared/columns/meteringpoint.columns';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

export const unbalancedQuantityTable: TableConfig<DashboardQueryUnbalancedQuantityResultDto> = {
  id: 'table-dashboard-unbalancedquantity',
  exportable: true,
  columnSelection: true,
  reorder: true,
  selectable: true,
  selectableType: 'multiple',
  fetchOnLoad: true,
  columns: [
    {
      title: 'common.date.date',
      key: 'occurrence',
      cellRenderer: DateCellComponent
    },
    {
      title: 'meter.id',
      key: 'meteringPointIdentification',
      width: 175,
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'meteringPointIdentification',
      }
    },
    meterNumberPartial,
    addressPartial,
    meteringPointTypePartial,
    physicalStatusPartial,
    {
      title: 'dashboard.table.mappedquadrant',
      key: 'mappedQuadrant'
    },
    {
      title: 'dashboard.table.nonmappedquadrant',
      key: 'nonMappedQuadrant'
    },
    {
      title: 'dashboard.table.consumptionnonmappedquadrant',
      key: 'consumptionNonMappedQuadrant'
    }
  ],
}
